export default input => {
  if (!/^<iframe[^>]*(?:\/>|><\/iframe>)$/.test(input)) return input

  const parser = new DOMParser()
  const doc = parser.parseFromString(input, 'text/html')
  const iframe = doc.querySelector('iframe')
  const allowed_attributes = ['src', 'width', 'height', 'frameborder', 'allowfullscreen', 'allow']

  if (!iframe) return input

  const attrs = Array.from(iframe.attributes)
    .filter(attr => allowed_attributes.includes(attr.name))
    .map(attr => attr.value ? `${attr.name}="${attr.value}"` : attr.name)

  return `<iframe ${attrs.join(' ')}></iframe>`
}